import { RootState } from "@src/reducers/store";
import React, { ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { checkPermissions, PermissionInput } from "./check-permissions";

interface RenderIfUserPermissionsRulesMatchProps {
  children: ReactNode;
  permissions: PermissionInput;
  mode?: "any" | "all" | "anyCompleteGroup" | "anyInEachGroup";
  invert?: boolean;
}

export const RenderIfUserPermissionsRulesMatch = ({
  children,
  permissions,
  mode = "any",
  invert = false,
}: RenderIfUserPermissionsRulesMatchProps) => {
  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );

  const [hasPermission, setHasPermission] = useState(false);

  useEffect(() => {
    if (authContext?.permissions) {
      const match = checkPermissions(
        authContext.permissions,
        permissions,
        mode,
      );
      setHasPermission(match);
    } else {
      setHasPermission(false);
    }
  }, [authContext, permissions, mode]);

  if (invert) return !hasPermission ? <>{children}</> : null;

  return hasPermission ? <>{children}</> : null;
};
